import { PawPrint } from "lucide-react";

export function Empty({ title = "Nothing here yet", subtitle, icon: Icon = PawPrint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center" data-testid="empty-state">
      <div className="h-16 w-16 rounded-2xl bg-pawkt-primary-soft flex items-center justify-center mb-4">
        <Icon className="h-7 w-7 text-pawkt-primary" />
      </div>
      <p className="font-display text-lg font-bold text-pawkt-text">{title}</p>
      {subtitle && <p className="text-sm text-pawkt-text-secondary mt-1 max-w-sm">{subtitle}</p>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function Loading({ label = "Loading" }) {
  return (
    <div className="flex items-center justify-center py-20" data-testid="loading">
      <div className="flex items-center gap-3 text-pawkt-text-secondary">
        <div className="h-5 w-5 animate-spin rounded-full border-2 border-pawkt-border-strong border-t-primary" />
        <span className="text-sm font-medium">{label}…</span>
      </div>
    </div>
  );
}
